import * as React from 'react'
import BaseIcon from 'react-icon-base'
import { IIconProps } from './interface'
import { EColors } from 'app/constants/colors'

const BlushEmoji = (props: IIconProps) => (
  <BaseIcon width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="translate(1.406 1.172)" stroke="#FFF" fill="none" fillRule="evenodd">
      <circle
        strokeWidth="1.532"
        fill={EColors.MEDIUM_GREY}
        strokeLinejoin="round"
        cx="12.797"
        cy="12.797"
        r="12.797"
      />
      <path d="M6.156 11.912a6.733 6.733 0 1 0 13.466 0H6.156z" strokeWidth="1.532" strokeLinejoin="round" />
      <path d="M9.132 8.194a1.488 1.488 0 0 0-2.976 0M19.622 8.194a1.488 1.488 0 0 0-2.976 0" strokeWidth="1.231" />
    </g>
  </BaseIcon>
)

export default BlushEmoji
